/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ServiceObjectAreaV1Dto = {
  /**
   * The unique identifier of the entity.
   */
  readonly id: string;
  /**
   * The date when the entity was created.
   */
  readonly createdAt: string;
  /**
   * The date when the entity was modified.
   */
  readonly modifiedAt: string;
  /**
   * The name of the area for internal use
   */
  name: string;
  /**
   * The type of the area.
   */
  type: ServiceObjectAreaV1Dto.type;
  /**
   * The type of use of the area.
   */
  typeOfUse: ServiceObjectAreaV1Dto.typeOfUse;
  /**
   * The size of the area in square meters
   */
  size: number;
};
export namespace ServiceObjectAreaV1Dto {
  /**
   * The type of the area.
   */
  export enum type {
    MAIN_AREA = 'main_area',
    ANCILLARY_AREA = 'ancillary_area',
  }
  /**
   * The type of use of the area.
   */
  export enum typeOfUse {
    SALES = 'sales',
    STORAGE = 'storage',
    AD_SPACE = 'ad_space',
    PARKING_AREA = 'parking_area',
    CONCESSION_AREA = 'concession_area',
    OFFICE_ADMINISTRATION = 'office_administration',
    PRACTICE = 'practice',
    LOGISTIC = 'logistic',
    GASTRONOMY = 'gastronomy',
    OTHER_APARTMENTS = 'other_apartments',
    OTHER_USE = 'other_use',
  }
}
